import axios from "axios";
import { WEB_PAGE_TO_PDF_API_KEY } from "../globals/const";

export const generatePdf = async (
  farmId,
  date,
  token,
  language,
  setReportLoading
) => {
  if (!token) {
    setReportLoading(false);
    return;
  }
  const url = `${window.location.origin}/farmer/am-satellite-data-report/${farmId}/${language}/${token}`;
  try {
    const response = await axios.post(
      "https://page-pdf.farmapp.in/generate-screenshot",
      { url },
      {
        headers: {
          accept: "application/json",
          "api-key": WEB_PAGE_TO_PDF_API_KEY,
          "Content-Type": "application/json",
        },
      }
    );
    const taskId = response.data.task_id;
    pollPdfStatus(taskId, farmId, date, setReportLoading);
  } catch (err) {
    console.error("Error generating PDF:", err);
    setReportLoading(false);
  }
};

const pollPdfStatus = async (taskId, farmId, date, setReportLoading) => {
  const maxAttempts = 60;
  let attempts = 0;
  const intervalId = setInterval(async () => {
    attempts++;

    try {
      const response = await axios.get(
        `https://page-pdf.farmapp.in/get-screenshot?task_id=${taskId}`,
        {
          headers: {
            accept: "application/json",
            "api-key": WEB_PAGE_TO_PDF_API_KEY,
          },
        }
      );
      if (response.data.status === "SUCCESS") {
        const { download_url } = response.data || {};
        handleFileDownload(download_url, farmId, date);
        clearInterval(intervalId);
        setReportLoading(false);
      } else if (attempts >= maxAttempts) {
        console.error("PDF generation timed out");
        clearInterval(intervalId);
        setReportLoading(false);
      }
    } catch (err) {
      console.error("Error polling PDF status:", err);
    }
  }, 5000);
};

const handleFileDownload = (downloadUrl, farm_id, date) => {
  if (!downloadUrl) {
    return;
  }

  const formattedDate = date.replace(/[\s-]/g, "");
  const fileName = `${farm_id}-${formattedDate}.pdf`;
  const fileDownloadUrl = `https://page-pdf.farmapp.in${downloadUrl}`;

  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: "DOWNLOAD_FILE",
        fileUrl: fileDownloadUrl,
        fileName: fileName,
      })
    );
    return;
  }
  downloadFileWithName(fileDownloadUrl, fileName);
};

const downloadFileWithName = (url, fileName) => {
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
